import React from 'react'
import './RegistrationItemList.css'
import useGetCompanyInfo from '../Hooks/useGetCompanyInfo'

const RegistrationItemList = () => {
    const { registrationProfits } = useGetCompanyInfo()
    return (
        <>
            <div className='row'>
                <div className='col panel-header-title'>
                    Zarejestruj się i zyskaj
                </div>

            </div>
            <div className='row'>
                <ul className='p-0'>
                    {registrationProfits.length > 0 && registrationProfits.map((item, index) => {
                        return <div className='label ListItem'>
                            <span style={{ color: 'var(--primary)', paddingRight: '15px', fontWeight: 'bold' }}>✓</span>{item.title}
                        </div>
                    })}
                </ul>
            </div>
        </>
    )
}

export default RegistrationItemList